import React, { useEffect } from 'react';
import { ReactModel } from '../../react-model/react-model';
import { useOnModelChange } from '../hooks/use-on-model-change';
import { useValidator } from '../hooks/use-validator';

/*
export interface IUILink{
    registerEle?:(scope:IMap, model:string, new_val:any)=>void;
    linkEle?:(scope:IMap, model:string, ele:HTMLElement)=>void;
}*/

export interface HTextareaProps<T> extends React.TextareaHTMLAttributes<any> {
	model: ReactModel<T>; //& IUILink,
	field?: keyof NonNullable<T>;

	/** Set the component properties when then model changes */
	onModelChange?: (state: T) => void | React.TextareaHTMLAttributes<any>;
	/** Set the model when then input element changes
	 * It behaves the same like setState((state)=>{...})
	*/
	onViewChange?: (state: T, new_value: any) => void | T;

	no_popover?: boolean;
	/** The word "ref" is reserved. We have to use ref2 */
	ref2?: { current: HTMLTextAreaElement | null };
}

export function HTextarea<T>({ model, field, ref2, onModelChange, onViewChange, no_popover, ...props }: HTextareaProps<T>) {
	const old_onchange = props.onChange;
	if (!ref2) ref2 = { current: null };

	if(field !== undefined){
		var { state, setState } = model.useModel(field as any);
		props.value = (state as string) || '';
		//add validator
		props = useValidator(model, field as any, ref2, props, no_popover);
	}else{
		props = {...props}//unfreeze the object for useOnModelChange
	}

	useOnModelChange(model, onModelChange, props);

	if(field === undefined && ! onModelChange){
		console.error('(HTA33)');//console.error('field or onModelChange expected');
	}

	return (
		<textarea
			{...props}
			ref={ref2}
			//value={(state as string) || ''}
			onChange={(e) => {
				if(field !== undefined){
					setState(e.currentTarget.value as any);
					model.validator(false)?.enable(field as any, true);
				}
				if(onViewChange){
					model.setState((state)=>{
						return onViewChange(state, e.currentTarget.value);
					})
				}
				old_onchange?.(e);
			}}
		></textarea>
	);
}
